
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAjjqzEDM6_kNhrY8U3R85Id1UulBv3L_c",
  authDomain: "care-dpc.firebaseapp.com",
  projectId: "care-dpc",
  storageBucket: "care-dpc.firebasestorage.app",
  messagingSenderId: "669978133645",
  appId: "1:669978133645:web:ec8fb9cbe13d40b19ccec4",
  measurementId: "G-RSK3JJDX0B"
};

const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);


export const requestForToken = async () => {
  try {
    console.log("Before request:", Notification.permission);
    const permission = await Notification.requestPermission();
    console.log("Permission result:", permission);

    if (permission !== "granted") {
      console.log("Permission not granted");
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey: "BMGxafCE22xwAuaJWhn5bNb7tSi891IXvUtyc3Vas32sSi8suYd78zTXvlEmpZGBrcth2yeOTSNs0nPE8jQu1lc"
    });

    return token;

  } catch (err) {
    console.log("Error getting token", err);
    return null;
  }
};

